import React from 'react';
import { connect } from 'react-redux';
import ComparisonPageButton from '../../Components/Comparison/ComparisonPageButton';

const ComparisonPageButtonContainer = props => (
    <ComparisonPageButton {...props} />
);

const mapStateToProps = state => {
    const { comparison } = state;
    return {
        ...comparison,
    };
};

export default connect(mapStateToProps)(ComparisonPageButtonContainer);
